<template>
  <div class="FinancialInformationInquiry">
    <div class="detial-top">
      <div class="detial-top-title">工会资金查询</div>
      <blank height="33"> </blank>
      <div class="balance-name">账户余额</div>
      <div class="balance-number">
        ￥{{ accountInformation.totalbalance || 0 }}
      </div>
      <img src="./img/FIIlogo.svg" alt="" class="detial-top-btn" />
    </div>
    <div class="detial-cont">
      <div class="detial-cont-view">
        <span>按月查询：</span>
        <a-select class="w100" v-model="year" @change="initSelectMonth">
          <a-select-option
            v-for="item in years"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</a-select-option
          >
        </a-select>
        <a-select v-model="month" class="w100 ml10">
          <a-select-option
            v-for="item in months"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</a-select-option
          >
        </a-select>
        <span class="ml10">按区间查询：</span>
        <a-range-picker
          class="w300"
          v-model="timeHorizon"
          :valueFormat="dateFormat"
        >
          <a-icon slot="suffixIcon" type="calendar"
        /></a-range-picker>

        <a-button class="ml20" type="primary" @click="subMit" icon="search">
          查询</a-button
        >
        <a-button class="ml10" @click="cancel()"> 取消 </a-button>
      </div>
      <blank height="2"> </blank>
      <div class="detial-cont-view">
        <a-row type="flex" justify="start">
          <a-col :span="4"> 统计： </a-col>
          <a-col :span="1">收入 </a-col>
          <a-col :span="2">
            <div class="detial-bottom-number">
              {{ accountInformation.totalincome }}
            </div>
          </a-col>
          <a-col :span="1"> 支出 </a-col>
          <a-col :span="2">
            <div class="detial-bottom-number">
              {{ accountInformation.totalspending }}
            </div>
          </a-col>
          <a-col :span="1"> 结余 </a-col>
          <a-col :span="2">
            <div class="detial-bottom-number">
              {{ accountInformation.totalbalance }}
            </div>
          </a-col>
        </a-row>
        <blank height="10"> </blank>
        <a-row type="flex" justify="start">
          <a-col :span="4"> 区间查询统计： </a-col>
          <a-col :span="1">收入</a-col>
          <a-col :span="2">
            <div class="detial-bottom-number">
              {{ accountInformation.income }}
            </div>
          </a-col>
          <a-col :span="1"> 支出 </a-col>
          <a-col :span="2">
            <div class="detial-bottom-number">
              {{ accountInformation.spending }}
            </div>
          </a-col>
          <a-col :span="1"> 结余 </a-col>
          <a-col :span="2">
            <div class="detial-bottom-number">
              {{ accountInformation.balance }}
            </div>
          </a-col>
        </a-row>
      </div>
      <blank height="20"> </blank>
      <div class="detial-cont-view">
        <a-table :pagination="false" :columns="columns" :data-source="data">
        </a-table>
        <div class="pagination">
          <a-pagination
            :current="page"
            :default-current="page"
            :total="total"
            :pageSize="size"
            @change="pageChange"
          />
        </div>
      </div>
    </div>
    <a-modal v-model="visible" title="录入余额" @ok="handleOk">
      <div class="role-formCont">
        <span>账户余额：</span>
        <a-input-number
          :min="0"
          :max="99999999999999999999"
          class="w300 ml20"
          placeholder="请输入账户余额"
          v-model="seveReq.balance"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: '年',
    dataIndex: 'year',
    key: 'year',
    align: 'center',
    width: 80
  },
  {
    title: '月',
    dataIndex: 'month',
    key: 'month',
    width: 80,
    align: 'center'
  },
  {
    title: '日',
    dataIndex: 'day',
    key: 'day',
    width: 80,
    align: 'center'
  },
  {
    title: '凭证号数',
    dataIndex: 'certificate',
    key: 'certificate',
    align: 'center'
  },
  {
    title: '明细摘要',
    dataIndex: 'detail',
    key: 'detail',
    align: 'left',
    ellipsis: true
  },

  {
    title: '借方金额',
    dataIndex: 'amount',
    key: 'amount',
    align: 'center'
  },
  {
    title: '贷方金额',
    dataIndex: 'theSum',
    key: 'theSum',
    align: 'center'
  }
  // {
  //   title: '结余',
  //   dataIndex: 'balance',
  //   key: 'balance',
  //   align: 'center'
  // }
]
import {
  saveFinancialInformationInquiry,
  getFinancialInformationInquiry,
  uploadFinancialInformationInquiry,
  deleteFinancialInformationInquiry
} from './api/api'
export default {
  data() {
    return {
      visible: false,
      year: '',
      month: '',
      yearsModel: null,
      years: [],
      monthsModel: null,
      months: [],
      seveReq: {
        income: 0,
        spending: 0
      },
      accountInformation: {}, // 账户信息
      data: [],
      columns,
      dateFormat: 'YYYY-MM-DD',
      timeHorizon: [], //时间范围
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 拉取列表
    load() {
      this.loading = true
      let params = {}
      params.page = this.page
      params.size = this.size
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        params.TimeStart = this.timeHorizon[0]
        params.TimeEnd = this.timeHorizon[1]
      } else {
        params.year = this.year
        params.month = this.month
      }
      getFinancialInformationInquiry(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.accountInformation = res.data.data
          this.data = res.data.data.financialInformationInquiryRes
          this.total = res.data.count
        }
      })
    },
    init() {
      // 获取年月列表
      var myDate = new Date()
      this.year = this.yearsModel = myDate.getFullYear() //获取当前年
      this.month = this.monthsModel = myDate.getMonth() + 1 //获取当前月
      this.initSelectYear(this.yearsModel)
      this.initSelectMonth(this.yearsModel)
      this.load()
    },
    initSelectYear(year) {
      this.years = []
      for (let i = 0; i < 20; i++) {
        this.years.push({ value: year - i, label: year - i + '年' })
      }
    },
    initSelectMonth(years) {
      //选择年分 更改月份列表
      let month = 12
      if (years == this.yearsModel) {
        month = this.monthsModel
      }
      this.months = []
      for (let i = 1; i <= month; i++) {
        this.months.push({ value: i, label: i + '月' })
      }
      this.months.reverse()
    },
    add() {
      this.visible = true
    },
    handleOk() {
      // 确认添加
      saveFinancialInformationInquiry(this.seveReq).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('添加成功')
          this.load()
          this.visible = false
        }
      })
    },
    beforeUpload() {
      return false
    },
    uploading(file) {
      this.$message.loading('导入中···', 0)
      let formDataChildren = new FormData()
      formDataChildren.append('file', file.file)
      uploadFinancialInformationInquiry(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('导入成功')
          this.page = 1
          this.load()
        }
      })
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    cancel() {
      //取消
      this.timeHorizon = []
      this.year = this.yearsModel
      this.month = this.monthsModel
      this.initSelectMonth(this.yearsModel)
    },
    subMit() {
      this.page = 1
      this.load()
    },
    ResetData() {
      deleteFinancialInformationInquiry().then((res) => {
        if (res.data.code == 0) {
          this.$message.success('重置数据成功！')
          this.cancel()
          this.subMit()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.FinancialInformationInquiry {
  .detial-top {
    background: #fff;
    padding: 0 50px 20px 50px;
    position: relative;
    .detial-top-title {
      height: 25px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      font-weight: bold;
    }
    .balance-name {
      height: 22px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
    }
    .balance-number {
      height: 39px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 30px;
    }
    .detial-top-btn {
      width: 203px;
      height: 135px;
      position: absolute;
      right: 87px;
      bottom: 20px;
    }
  }
  .detial-cont {
    margin: 24px 16px;
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .personage {
        // height: 360px;
        border: #e9e9e9 solid 1px;
        border-radius: 4px;
        .personage-title {
          padding-left: 24px;
          height: 44px;
          color: rgba(0, 0, 0, 0.85);
          background-color: rgba(250, 250, 250, 1);
          border-bottom: #e9e9e9 solid 1px;
          border-radius: 4px;
          font-size: 14px;
          line-height: 44px;
        }
        .personage-cont {
          padding: 16px 24px 0 24px;
        }
      }
      .detial-bottom-number {
        color: rgba(0, 0, 0, 0.65);
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/FinancialInformationInquiry/indexLook.vue